import React, { Component }  from 'react';
import { Rect, Text, Group, Image } from 'react-konva';
import { nodeWidth,
  nodeHeight,
  pedigreeNodeHeight,
  pedigreeIsTallNodeHeight,
  picDim,
  pedigreeIsTallPicDim,
  pedigreePicDim,
  fullNameFontSize,
  fullNameLargeFontSize,
} from '../../../library/constants';
import {
 calcFullNameObj,
 calcNodeColorObj,
} from '../../../library/calc';


class DragNode extends Component {

  constructor(props){
    super(props);

    this.picDimAdapted = ( this.props.dragNodeObj.isPedigree ? pedigreePicDim: picDim);
    this.picDimAdapted = ( this.props.dragNodeObj.isPedigree && this.props.dragNodeObj.pedigreeIsTall ? pedigreeIsTallPicDim: this.picDimAdapted);

  }

  componentDidMount(){

  }

  componentDidUpdate(){

  }

  render () {

    const {
      photoBorderColor,
      maleCustomColor,
      femaleCustomColor,
      unGenderedCustomColor,
      fontSizeChoice,
    } =
    this.props;

    const {
      img,
      g,
    } =
    this.props.dragNodeObj;

    let {
      left,
      top,
      nm,
    } = this.props.dragNodeObj;


    const margin = 2;
    const fullNameObj = calcFullNameObj({nm, left, top});
    const nodeColorObj = calcNodeColorObj({
      g,
      nodeObj: this.props.dragNodeObj,
      maleCustomColor,
      femaleCustomColor,
      unGenderedCustomColor,
      undefinedGenderColor: '#DADADA',
    });

    let heightOfNode = ( this.props.dragNodeObj.isPedigree ? pedigreeNodeHeight: nodeHeight);
    heightOfNode = ( this.props.dragNodeObj.isPedigree && this.props.dragNodeObj.pedigreeIsTall ? pedigreeIsTallNodeHeight: heightOfNode);

    let adaptedLeftFullName = ( this.props.dragNodeObj.isPedigree ? 14: 0);
    adaptedLeftFullName = ( this.props.dragNodeObj.isPedigree && this.props.dragNodeObj.pedigreeIsTall ? 8: adaptedLeftFullName);

    let whichGenderPlaceHolder = undefined;

    switch(g) {
      case 'm':
          whichGenderPlaceHolder = this.props.placeholderImage_m
          break;
      case 'f':
          whichGenderPlaceHolder = this.props.placeholderImage_f
          break;
      case 'u':
          whichGenderPlaceHolder = this.props.placeholderImage_u
          break;
        default:
    }

    return (
      <Group
        draggable={true}
        x={0}
        y={0}
        onMouseDown={()=>{
          this.props.setMouseMovementActionMode_ForCntrlDnMoveFeature('find_drop');
        }}
        onMouseUp={()=>{
          this.props.dropOnTargetForCtrlKeyDnMoveFeature();
          this.props.setMouseMovementActionMode_ForCntrlDnMoveFeature('find_drag');
        }}
      >
        <Rect
          shadowBlur={5}
          shadowOffset={{x: 1, y: 2}}
          shadowOpacity={.3}
          x={left}
          y={top}
          width={nodeWidth}
          height={heightOfNode}
          cursor={`pointer`}
          strokeWidth={.5}
          stroke={nodeColorObj.strokeColor}
          fillLinearGradientStartPoint={{ x : nodeWidth/2, y : nodeColorObj.yStartPointGradient}}
          fillLinearGradientEndPoint={{ x : nodeWidth/2, y : nodeColorObj.yEndPointGradient}}
          fillLinearGradientColorStops={nodeColorObj.fillLinearGradientColorStops}
        />
        <Text
          x={(fullNameObj.left - adaptedLeftFullName)}
          y={fullNameObj.top}
          text={`${fullNameObj.nm}`}
          width={fullNameObj.width}
          height={fullNameObj.height}
          lineHeight={fullNameObj.lineHeight}
          // fontSize={fullNameObj.fontSize}
          fontSize={ fontSizeChoice === 'default' ? fullNameFontSize: fullNameLargeFontSize}
          fontFamily={fullNameObj.fontFamily}
          fontStyle={fullNameObj.fontStyle}
          fill={fullNameObj.fill}
        />
        {
            <Image
              image={ this.props.dragNodeObj.img.type === 'real' ? this.props.dragNodeObj.img.image: whichGenderPlaceHolder }
              width={this.picDimAdapted}
              height={this.picDimAdapted}
              x={left + margin}
              y={top + margin}
              strokeWidth={1}
              stroke={photoBorderColor}

              crop={{
                x: img.cropStartX,
                y: img.cropStartY / ( img.heightIsDoubleWidth ? img.diffPercent: 1),
                width: img.sideLength,
                height: img.sideLength
              }}

            />
        }
      </Group>
    );

  }
}

export default DragNode;

